<h1 mat-dialog-title>Unit Setup</h1>

<div mat-dialog-content>
  <p>Setup the project units by uploading the excel template.</p>
</div>
<div>
  <mat-form-field class="example-full-width">
    <input matInput placeholder="Upload Attachment" readonly (click)="fileInput.click()" [(ngModel)]="fileName" />
    <mat-icon matSuffix>publish</mat-icon>
  </mat-form-field>
  <input type="file" name="pic" style="display: none" (change)="fileChangeEvent($event)"
    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    #fileInput />
</div>
<div mat-dialog-actions class="pull-right">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button cdkFocusInitial (click)="upload()">Upload Now</button>
</div>